import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import {
  GetWorkflowApiArg,
  GetWorkflowApiResponse,
} from '../../types/k2/workflows';

type Request = {
  workflowId: string;
  version?: number | null;
};

type ServerRequest = GetWorkflowApiArg;
type ServerResponse = GetWorkflowApiResponse;

export const getWorkflowK2 = async (
  request: Request,
  options: ServiceRequestConfig = {},
) => {
  const params = mapParams(request);

  const serverResponse: ServerResponse = await k2.get(
    `/workflows/${request.workflowId}`,
    {
      params,
      showErrorToast: true,
      ...options,
    },
  );

  return mapResponse(serverResponse);
};

const mapParams = (request: Request): ServerRequest => {
  return {
    workflowId: request.workflowId,
    version: request.version ?? undefined,
  };
};

const mapResponse = (serverResponse: ServerResponse) => {
  return {
    id: serverResponse.data.id,
    ...serverResponse.data.attributes,
  };
};
